import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea } from "rbx";
import { BooleanInput, PhoneNumberInput } from "../inputs";

const LocationContactForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field kind="group">
      <Control expanded>
        <Label>Name</Label>
        <Input
          autocomplete="new"
          name="Name"
          type="text"
          value={inputs.Name}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Primary</Label>
        <BooleanInput
          name="IsPrimary"
          value={inputs.IsPrimary}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Active</Label>
        <BooleanInput name="Active" value={inputs.Active} onChange={onChange} />
      </Control>
    </Field>

    <Field>
      <Control>
        <Label>Description</Label>
        <Textarea
          name="Description"
          rows="3"
          value={inputs.Description}
          onChange={onChange}
        />
      </Control>
    </Field>

    <Field kind="group">
      <Control expanded>
        <Label>Telephone</Label>
        <PhoneNumberInput
          name="Telephone"
          value={inputs.Telephone}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Extension</Label>
        <Input
          autocomplete="new"
          name="Extension"
          type="number"
          value={inputs.Extension}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Fax No</Label>
        <PhoneNumberInput
          name="FaxNo"
          value={inputs.FaxNo}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Email</Label>
        <Input
          autocomplete="new"
          name="Email"
          type="email"
          value={inputs.Email}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

LocationContactForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default LocationContactForm;
